// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__kepk7","avatar":"style_avatar__23rwY","menuIcon":"style_menuIcon__IAZRT"};